import React from "react";
import HorseIcon from "assets/icons/notifications/horse-notification-success.svg?react";
import { Input } from "components/ui/input";
import { Button } from "components/ui/button";
import { Loader2 } from "lucide-react";

const ConfirmSignUpForm = ({
  countdown,
  showCountDown,
  disabled,
  onResend,
  loading,
  errors,
  register,
}) => {
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  return (
    <>
      <div className="simple-notification-modal-content ">
        <div className="simple-notification-content flex flex-col items-center pt-[3px] pb-[12px]">
          <h3 className="text-center font-barlowCondensed uppercase font-bold  text-[40px] text-[var(--color-primary)]">
            Confirm your email address
          </h3>
          <div className="simple-content-icon">
            <HorseIcon />
          </div>
          <span className="font-montserrat text-center text-[17px] leading-[120%] mt-[12px]  text-[#343434]">
            An email with a confirmation code has been sent to the specified
            email address, enter it below
          </span>
          <div className="w-full mt-[20px]">
            <Input
              autoFocus
              name="prompt_code"
              label="Code"
              placeholder={"Enter code"}
              required
              {...register("prompt_code")}
            />
          </div>
          {errors.prompt_code && (
            <p className="text-red-400 error-text">
              {errors.prompt_code.message}
            </p>
          )}
          <div className="flex flex-col items-center">
            {showCountDown && (
              <span className="timer-text font-montserrat mt-2">
                {formatTime(countdown)} remaining
              </span>
            )}
            <Button
              type="button"
              size="lg"
              className={`modal_form_btn ${disabled && "!bg-gray-300"} mt-4`}
              disabled={disabled || loading}
              onClick={onResend}
            >
              Resend code
            </Button>

            <Button
              // variant="outline"
              type="submit"
              size="xl"
              className="modal_form_btn !mt-4"
              disabled={loading}
            // variant="default"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Confirm"}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmSignUpForm;
